import {
  Badge,
  BadgeProps,
  Button,
  ButtonProps,
  Divider,
  Menu,
  MenuItem,
  MenuProps,
  Typography
} from '@material-ui/core'
import React, { ReactNode, useState } from 'react'
import styles from './AppHeaderMenuItem.module.css'
import IconUpdate from '@material-ui/icons/Update'
import { classes } from '../../../utils/css'

type AppHeaderMenuOptionsProps = {
  label: string
  icon?: ReactNode
}

export type AppHeaderMenuItemProps = {
  buttonProps?: ButtonProps | Record<string, string>
  ref?: React.RefObject<HTMLButtonElement>
  children?: React.ReactNode
  badge?: BadgeProps
  menu?: MenuProps
  menuOptions?: AppHeaderMenuOptionsProps[]
  onMenuSelected?: (key?: { key: number; label: string }) => void
  emptyMessage?: string
}

function AppHeaderMenuItem({
  onMenuSelected = () => {},
  ...props
}: AppHeaderMenuItemProps): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  function onOpen(event: React.MouseEvent<HTMLButtonElement>): void {
    setAnchorEl(event.currentTarget as HTMLElement)
  }
  function onClose(): void {
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        {...{
          ...props.buttonProps
        }}
        className={classes(styles.button, props.buttonProps?.className || '')}
        onClick={(event) => onOpen(event)}
      >
        <Badge {...props.badge}>{props.children}</Badge>
      </Button>
      <Menu
        {...props.menu}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={onClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        {!props.menuOptions || props.menuOptions.length === 0 ? (
          <MenuItem className={styles.menuItem}>
            <IconUpdate />
            <Typography className={styles.menuItemText} variant='caption'>
              {props.emptyMessage || 'Coming Soon'}
            </Typography>
          </MenuItem>
        ) : (
          props.menuOptions.map((option, key) => (
            <div key={key}>
              {key > 0 ? (
                <Divider className={styles.menuItemDivider} />
              ) : undefined}
              <MenuItem
                className={styles.menuItem}
                onClick={() => {
                  onClose()
                  onMenuSelected({ key, label: option.label })
                }}
              >
                {option.icon ? option.icon : undefined}
                <Typography className={styles.menuItemText} variant='caption'>
                  {option.label}
                </Typography>
              </MenuItem>
            </div>
          ))
        )}
      </Menu>
    </>
  )
}

export default AppHeaderMenuItem
